var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('LinkStyleGuide',{attrs:{"icon-name":"icon-link","text":_vm.title},on:{"open-url":function($event){return _vm.openActivity()}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }